import { RefreshCw, Trash2, CheckCircle, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAdmin } from './AdminContext';
import { StatusBadge } from './AdminShared';

export const AdminEventsTab = () => {
  const { schedulerStatus, eventSubmissions, syncVenueEvents, cleanupPastEvents, updateRegistrationStatus } = useAdmin();

  return (
    <>
      {schedulerStatus && (
        <Card className="bg-blue-500/10 border-blue-500/30 mb-6">
          <CardContent className="py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`w-3 h-3 rounded-full ${schedulerStatus.scheduler_active ? 'bg-green-500 animate-pulse' : 'bg-red-500'}`} />
                <div>
                  <p className="font-medium text-blue-400">Auto-Sync Scheduler</p>
                  <p className="text-xs text-muted-foreground">{schedulerStatus.scheduler_active ? 'Active' : 'Inactive'} - Next sync: {schedulerStatus.hours_until_next_sync}h - {schedulerStatus.sync_time}</p>
                </div>
              </div>
              <Button size="sm" variant="outline" onClick={syncVenueEvents} className="text-blue-400 border-blue-500/50"><RefreshCw size={14} className="mr-1" /> Sync Now</Button>
            </div>
          </CardContent>
        </Card>
      )}

      <div className="flex flex-wrap gap-2 mb-6">
        <Button variant="outline" onClick={syncVenueEvents} className="bg-green-500/10 border-green-500/50 text-green-400 hover:bg-green-500/20"><RefreshCw size={14} className="mr-2" /> Sync Venue Events</Button>
        <Button variant="outline" onClick={cleanupPastEvents} className="bg-orange-500/10 border-orange-500/50 text-orange-400 hover:bg-orange-500/20"><Trash2 size={14} className="mr-2" /> Remove Past Events</Button>
      </div>

      <p className="text-sm text-muted-foreground mb-4">
        Events sync from: <span className="text-green-400">Gluek's</span> - <span className="text-blue-400">Day Block Brewing</span> - <span className="text-purple-400">Green Room</span>
        <br /><span className="text-yellow-400">*</span> Friday/Saturday <strong>MUSIC</strong> events from Gluek's and Day Block are auto-featured on the homepage.
      </p>

      <h2 className="text-xl font-semibold mb-4">All Event Submissions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {eventSubmissions.map(event => (
          <Card key={event.id} className="bg-card border-border">
            <CardHeader className="pb-2">
              <div className="flex items-center justify-between">
                <CardTitle className="text-lg">{event.event_title}</CardTitle>
                <StatusBadge status={event.status} />
              </div>
              <CardDescription>{event.venue_name} - {event.date}</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground mb-2">Submitted by: {event.submitter_name}</p>
              {event.status === 'pending' && (
                <div className="flex gap-2">
                  <Button size="sm" variant="outline" className="flex-1" onClick={() => updateRegistrationStatus('event-submissions', event.id, 'published')}><CheckCircle size={14} className="mr-1" /> Publish</Button>
                  <Button size="sm" variant="destructive" className="flex-1" onClick={() => updateRegistrationStatus('event-submissions', event.id, 'rejected')}><XCircle size={14} className="mr-1" /> Reject</Button>
                </div>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
};
